import { BootstrapGrowlService, BootstrapAlertType} from 'ngx-bootstrap-growl';
import { Injectable } from '@angular/core';
import { AppComponent } from './../app.component';

@Injectable()
export class GrowlManager {

    private error_duration: number;
    private warning_duration: number;
    private success_duration: number; // spo.growl.info_duration in params service...

    constructor(private bootstrapGrowlService: BootstrapGrowlService) {}

    setErrorDuration(value: number) { this.error_duration = value; }
    setWarningDuration(value: number) { this.warning_duration = value; }
    setSuccessDuration(value: number) { this.success_duration = value; }
    
    check(value) {
        this.checkForErrors(value);
        this.checkForSuccess(value);
        this.checkForWarning(value);
    }

    showError(value) {
        this.bootstrapGrowlService.addAlert(value,BootstrapAlertType.DANGER,this.error_duration);
    }
    
    showWarning(value) {
        this.bootstrapGrowlService.addAlert(value,BootstrapAlertType.WARNING,this.warning_duration);
    }
    
    showSuccess(value) {
        this.bootstrapGrowlService.addAlert(value,BootstrapAlertType.SUCCESS,this.success_duration);
    }
    
    showCustomTimeError(value, time) {
        this.bootstrapGrowlService.addAlert(value,BootstrapAlertType.DANGER,time);
    }
    
    showCustomTimeWarning(value, time) {
        this.bootstrapGrowlService.addAlert(value,BootstrapAlertType.WARNING,time);
    }
    
    showCustomTimeSuccess(value, time) {
        this.bootstrapGrowlService.addAlert(value,BootstrapAlertType.SUCCESS,time);
    }
    
    checkForErrors(value) {
        for (let message of value.bapi_return_list.message_list) {
            if (message.type === 'E') {
                //this.bootstrapGrowlService.addAlert(message.message,BootstrapAlertType.DANGER,this.error_duration);
                this.showError(message.message);
            }
        }
    }
    
    checkForSuccess(value) {
        for (let message of value.bapi_return_list.message_list) {
            if (message.type === 'S') {
                //this.bootstrapGrowlService.addAlert(message.message,BootstrapAlertType.SUCCESS,this.success_duration);
                this.showSuccess(message.message);
            }
        }
    }
    
    checkForWarning(value) {
        for (let message of value.bapi_return_list.message_list) {
            if (message.type === 'W' || message.type === 'I') {
                //this.bootstrapGrowlService.addAlert(message.message,BootstrapAlertType.WARNING,this.warning_duration);
                this.showWarning(message.message);
            }
        }
    }

    showMessageByType(message, messageType) {
        switch(messageType){
            case "S":
                //this.bootstrapGrowlService.addAlert(message,BootstrapAlertType.SUCCESS,this.success_duration);
                this.showSuccess(message);
                break;
            case "W":
                //this.bootstrapGrowlService.addAlert(message,BootstrapAlertType.WARNING,this.warning_duration);
                this.showWarning(message);
                break;
            case "I":
                //this.bootstrapGrowlService.addAlert(message,BootstrapAlertType.WARNING,this.warning_duration);
                this.showWarning(message);
                break;
            case "E":
                //this.bootstrapGrowlService.addAlert(message,BootstrapAlertType.DANGER,this.error_duration);
                this.showError(message);
                break;                
            }
    } 

    //let assume messages is a list of message of the same type
    showMessageList(messages) {
        for(let message of messages){
                this.showMessageByType(message.message, message.type);              
            }
    }

    showMessagesByResponse(data) {
        if(data.hasOwnProperty('bapi_return_list')){
            if(data.bapi_return_list.hasOwnProperty('message_list')){
                if(data.bapi_return_list.message_list.length > 0){
                    this.showMessageList(data.bapi_return_list.message_list);
                }
            }else{
                if(data.bapi_return_list.length > 0){
                    this.showMessageList(data.bapi_return_list);
                }
            }
        }        
    }
    
    checkForErrorInResponse(response){
        let result = false;
        let result2 = false;
        result = response.bapi_return_code && response.bapi_return_code.return_code && response.bapi_return_code.return_code === "4";
        
        if(response.hasOwnProperty('bapi_return_list')){
            if(response.bapi_return_list.hasOwnProperty('message_list')){
                if(response.bapi_return_list.message_list.length > 0){
                    for (let message of response.bapi_return_list.message_list) {
                        if (message.type === 'E') {
                            result2 = true;
                            break;
                        }
                    }
                }
            }else{
                if(response.bapi_return_list.length > 0){
                    for (let message of response.bapi_return_list.message_list) {
                        if (message.type === 'E') {
                            result2 = true;
                            break;
                        }
                    }
                }
            }
        } 

        return result || result2;
    }
}



// WEBPACK FOOTER //
// ./src/app/manager/growl.manager.ts